module.exports = __webpack_public_path__ + "img/202602_04.2ad32b8e.png";